// eslint-disable-next-line jira/filename-case
import React from 'react';
import { NAVIGATION_APPS_NAV_ITEM_NUDGE_ID } from '@jira/platform__onboarding-core/src/constants.tsx';
import { OnboardingNudgeErrorBoundary } from '@jira/platform__onboarding-quickstart-core/src/common/ui/onboarding-nudge-error-boundary/index.tsx';
import type { QuickstartNudgeWrapperBaseProps } from '@jira/platform__onboarding-quickstart-core/src/common/ui/quickstart-nudge/types.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const NavigationAppsNavItemLazy = lazyAfterPaint(
	() =>
		import(
			/* webpackChunkName: "async-software-onboarding-navigation-apps-nudge" */ './NavigationAppsNavItemWrapperNudge.tsx'
		).then((exportedModule) => exportedModule.NavigationAppsNavItemWrapperNudge),
	{
		ssr: false,
	},
);
export const NavigationAppsNavItemWrapperNudgeAsync = ({
	children,
	isInsideMenu,
}: QuickstartNudgeWrapperBaseProps): React.JSX.Element => (
	<OnboardingNudgeErrorBoundary
		id={NAVIGATION_APPS_NAV_ITEM_NUDGE_ID}
		fallback={children}
		attributes={{
			nudgeId: NAVIGATION_APPS_NAV_ITEM_NUDGE_ID,
		}}
	>
		<Placeholder name="navigation-apps-nav-item-lazy" fallback={<>{children}</>}>
			<NavigationAppsNavItemLazy
				nudgeId={NAVIGATION_APPS_NAV_ITEM_NUDGE_ID}
				isInsideMenu={isInsideMenu}
			>
				{children}
			</NavigationAppsNavItemLazy>
		</Placeholder>
	</OnboardingNudgeErrorBoundary>
);
